import React from 'react'

import SideBar from "../../components/UserDashboard/SideBar";
import EfficiencyHeader from '../../components/Efficiency/EfficiencyHeader';
import EfficiencyCard from '../../components/Efficiency/efficiencyCard';
import EnergyUsageHistory from '../../components/Efficiency/EnergyUsageHistory';
import PropTypes from 'prop-types';

EfficiencyCard.propTypes = {
  type: PropTypes.oneOf(['baseline', 'goal', 'meter']),
  value: PropTypes.number,
  onSetGoal: PropTypes.func,
};

function EfficiencyDashboard() {

    return (
    <>
    <div className='flex relative'>

<div >
            <SideBar />
             </div>


             
             
        <div >
          <div className='mt-40 ml-[1250px]'>
          <EfficiencyHeader />

          </div>

<div className='mt-10 ml-10'>
<EfficiencyCard />

</div>
<div className='mt-10 ml-10'>
<EnergyUsageHistory/>


</div>

      </div>
        </div>


      
    

    </>
  )
}

export default EfficiencyDashboard
